export default __webpack_public_path__ + "static/media/agustin11.c034c14b.png";